import { useState } from "react";
import * as Animate from "react-reveal";
import Avatar1 from "../../../assets/images/png/avatars/1.webp";
import Avatar2 from "../../../assets/images/png/avatars/2.webp";
import Avatar3 from "../../../assets/images/png/avatars/3.webp";

const countries = [
  {
    flag: "🇳🇬",
    name: "Nigeria",
    payrollLabel: "NG Payroll",
    people: "32",
    currency: "NGN",
    status: "Ready",
    grossPayroll: "$41,280",
    workers: [
      {
        img: Avatar1,
        name: "Ada O.",
        role: "Product Designer",
        type: "Employee",
        payout: "₦1,850,000",
      },
      {
        img: Avatar2,
        name: "Chidi E.",
        role: "Data Engineer",
        type: "Contractor",
        payout: "₦1,420,000",
      },
      {
        img: Avatar3,
        name: "Tunde K.",
        role: "Product Manager",
        type: "Employee",
        payout: "₦2,100,000",
      },
    ],
  },
  {
    flag: "🇰🇪",
    name: "Kenya",
    payrollLabel: "KE Payroll",
    people: "18",
    currency: "KES",
    status: "Ready",
    grossPayroll: "$23,220",
    workers: [
      {
        img: Avatar1,
        name: "Wangari M.",
        role: "Product Designer",
        type: "Employee",
        payout: "KSh 210,000",
      },
      {
        img: Avatar2,
        name: "Achieng O.",
        role: "Data Engineer",
        type: "Contractor",
        payout: "KSh 175,000",
      },
      {
        img: Avatar3,
        name: "Otieno K.",
        role: "Product Manager",
        type: "Employee",
        payout: "KSh 240,000",
      },
    ],
  },
  {
    flag: "🇬🇧",
    name: "United Kingdom",
    payrollLabel: "UK Payroll",
    people: "12",
    currency: "GBP",
    status: "Review",
    grossPayroll: "$30,960",
    workers: [
      {
        img: Avatar1,
        name: "Olivia P.",
        role: "Product Designer",
        type: "Employee",
        payout: "£3,200",
      },
      {
        img: Avatar2,
        name: "James H.",
        role: "Data Engineer",
        type: "Contractor",
        payout: "£2,650",
      },
      {
        img: Avatar3,
        name: "Daniel R.",
        role: "Product Manager",
        type: "Employee",
        payout: "£3,800",
      },
    ],
  },
  {
    flag: "🇺🇸",
    name: "United States",
    payrollLabel: "US Payroll",
    people: "24",
    currency: "USD",
    status: "Ready",
    grossPayroll: "$153,730",
    workers: [
      {
        img: Avatar1,
        name: "Wanjiku N.",
        role: "Product Designer",
        type: "Employee",
        payout: "$4,820",
      },
      {
        img: Avatar2,
        name: "Amara O.",
        role: "Data Engineer",
        type: "Contractor",
        payout: "$3,950",
      },
      {
        img: Avatar3,
        name: "David K.",
        role: "Product Manager",
        type: "Employee",
        payout: "$5,240",
      },
    ],
  },
];

const markStyle = {
  background: "linear-gradient(transparent 66%, #fbaf1be6 0)",
  padding: "0 0.08em",
  color: "inherit",
};

const PayCommandCentreSection = () => {
  const [selectedCountry, setSelectedCountry] = useState(countries[0].name);
  const active =
    countries.find((c) => c.name === selectedCountry) || countries[0];
  const isReady = active.status === "Ready";

  const metrics = [
    {
      label: "People in cycle",
      value: active.people,
      small: "All records available",
    },
    {
      label: "Gross payroll",
      value: active.grossPayroll,
      small: "Converted for overview",
    },
    {
      label: "Payroll status",
      value: active.status,
      small: isReady ? "Ready for approval" : "Needs your review",
    },
  ];

  return (
    <section
      className="py-16 lg:py-[105px] px-6 lg:px-8"
      style={{ background: "#edf2ff" }}
      id="product"
    >
      <div className="container mx-auto">
        <Animate.Fade bottom>
          <div className="max-w-[760px] mb-10 lg:mb-[47px]">
            <p className="flex items-center gap-3 text-primary text-[15px] font-black tracking-[0.11em] uppercase mb-4">
              <span className="w-10 h-[3px] bg-secondary inline-block shrink-0"></span>
              The Payroll Command Centre
            </p>
            <h2
              className="text-primary tracking-[-0.052em] leading-[1.04] font-black mb-5"
              style={{ fontSize: "clamp(40px, 4.5vw, 65px)" }}
            >
              One clear view of{" "}
              <mark style={markStyle}>every country and every person.</mark>
            </h2>
            <span className="text-[#5c6274] text-[18px] leading-[1.7] max-w-[780px] block">
              Finance gets the oversight it needs. Your people get the clarity
              they deserve.
            </span>
          </div>
        </Animate.Fade>

        <Animate.Fade bottom>
          <div
            className="bg-white border border-[#cfd8ed] rounded-[26px] grid pay-grid-workspace overflow-hidden"
            style={{ boxShadow: "0 28px 80px rgba(20,28,79,0.12)" }}
          >
            <aside
              className="border-b lg:border-b-0 lg:border-r border-[#dce3f1] py-6 px-[18px]"
              style={{ background: "#f8faff" }}
            >
              <p className="text-[#8f5d00] tracking-[0.1em] uppercase text-[15px] font-black mx-[10px] mb-[15px]">
                Countries
              </p>
              {countries.map((country) => (
                <button
                  key={country.name}
                  type="button"
                  onClick={() => setSelectedCountry(country.name)}
                  aria-pressed={country.name === selectedCountry}
                  className={`w-full text-left grid pay-grid-aside-btn items-center gap-[9px] rounded-xl px-3 py-[14px] border transition-colors ${
                    country.name === selectedCountry
                      ? "bg-white border-[#cfdaee]"
                      : "bg-transparent border-transparent hover:bg-white/60"
                  }`}
                  style={
                    country.name === selectedCountry
                      ? { boxShadow: "0 9px 24px rgba(30,40,80,0.07)" }
                      : undefined
                  }
                >
                  <span className="text-2xl">{country.flag}</span>
                  <p className="grid gap-[3px] m-0 text-left">
                    <strong className="text-primary text-[15px]">
                      {country.name}
                    </strong>
                    <small className="text-[#5c6274] text-[15px]">
                      {country.people} people · {country.currency}
                    </small>
                  </p>
                  <b
                    className={`text-[15px] font-normal justify-self-end ${
                      country.status === "Ready"
                        ? "text-[#2a7444]"
                        : "text-[#946200]"
                    }`}
                  >
                    {country.status}
                  </b>
                </button>
              ))}
              <a
                href="https://app.utiva.co/signup?goal=workforce"
                target="_blank"
                rel="noreferrer noopener"
                className="text-primary block text-[15px] font-black mx-[10px] mt-[18px] hover:text-[#03046b] transition"
              >
                + Add a country
              </a>
            </aside>

            <div className="min-w-0 p-5 sm:p-[30px]">
              <header className="flex flex-col sm:flex-row sm:justify-between items-start sm:items-center gap-5 border-b border-[#dce3f1] pb-[22px]">
                <div className="flex items-center gap-[13px]">
                  <span style={{ fontSize: "42px" }}>{active.flag}</span>
                  <p className="grid gap-[3px] m-0">
                    <small className="text-[#946200] text-[15px] font-black">
                      {active.payrollLabel}
                    </small>
                    <strong className="text-primary text-2xl">
                      {active.name}
                    </strong>
                  </p>
                </div>
                <button
                  type="button"
                  className="border border-[#dce3f1] bg-white text-primary rounded-[9px] px-[13px] py-[9px] text-[15px] font-black whitespace-nowrap"
                  style={{ minHeight: "42px" }}
                >
                  Download summary ↓
                </button>
              </header>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 py-6">
                {metrics.map((metric) => (
                  <article
                    key={metric.label}
                    className="border border-[#dfe5f2] rounded-2xl grid gap-[6px] p-5"
                  >
                    <span className="text-[#5c6274] text-[15px]">
                      {metric.label}
                    </span>
                    <strong className="text-primary text-[29px]">
                      {metric.value}
                    </strong>
                    <small className="text-[#5c6274] text-[15px]">
                      {metric.small}
                    </small>
                  </article>
                ))}
              </div>

              <div className="border border-[#dfe5f2] rounded-[15px] overflow-x-auto">
                <div className="min-w-[640px]">
                  <div
                    className="grid pay-grid-worker-table items-center gap-[14px] px-4 py-3 text-[#5c6274] text-[15px] font-black"
                    style={{ background: "#f3f6fc" }}
                  >
                    <span>Person</span>
                    <span>Type</span>
                    <span>Status</span>
                    <span>Payout</span>
                  </div>
                  {active.workers.map((worker) => (
                    <article
                      key={worker.name}
                      className="grid pay-grid-worker-table items-center gap-[14px] px-4 py-3 border-t border-[#e8edf6]"
                    >
                      <p className="flex items-center gap-[11px] m-0">
                        <img
                          src={worker.img}
                          alt=""
                          className="rounded-full object-cover"
                          style={{ width: "44px", height: "44px" }}
                        />
                        <span className="grid gap-[3px]">
                          <strong className="text-primary text-[15px]">
                            {worker.name}
                          </strong>
                          <small className="text-[#5c6274] text-[15px]">
                            {worker.role}
                          </small>
                        </span>
                      </p>
                      <span className="text-[#5c6274] text-[15px]">
                        {worker.type}
                      </span>
                      <b className="text-[#1c7743] text-[15px] font-normal">
                        Verified
                      </b>
                      <strong className="text-primary text-[15px]">
                        {worker.payout}
                      </strong>
                    </article>
                  ))}
                </div>
              </div>

              <footer className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-5 pt-[22px]">
                <p
                  className="grid gap-x-[11px] gap-y-[2px] m-0"
                  style={{ gridTemplateColumns: "42px 1fr" }}
                >
                  <span
                    className="rounded-full grid place-items-center text-[19px]"
                    style={{
                      gridRow: "span 2",
                      width: "42px",
                      height: "42px",
                      color: isReady ? "#15713a" : "#8f5d00",
                      background: isReady ? "#e8f7ed" : "#fdf1da",
                    }}
                  >
                    {isReady ? "✓" : "!"}
                  </span>
                  <strong className="text-primary text-[16px]">
                    {isReady
                      ? "Payroll is ready to move forward"
                      : "This country cycle needs a quick review"}
                  </strong>
                  <small className="text-[#5c6274] text-[15px]">
                    {isReady
                      ? "Your specialist has checked this country cycle."
                      : "Your specialist flagged items that need your input."}
                  </small>
                </p>
                <a
                  href="https://app.utiva.co/signup?goal=workforce"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="bg-primary text-white rounded-[10px] inline-flex items-center justify-center px-[17px] py-[11px] text-[15px] font-black whitespace-nowrap"
                  style={{ minHeight: "46px" }}
                >
                  {isReady ? "Review & approve →" : "Review details →"}
                </a>
              </footer>
            </div>
          </div>
        </Animate.Fade>
      </div>
    </section>
  );
};

export default PayCommandCentreSection;
